import {APP_LOAD_NEW_SEND_CONTRACT_APPROVES, APP_LOAD_USE_BRANCHES, APP_SEND_CONTRACT_APPROVE_ALERT_CLOSE} from "@/store/modules/app/actions";

import SendContractApproveService from "@/services/send.contract.approve.service";
import BranchService from "@/services/branch.service"
import Moment from "moment";
export default {
    state: {
        sendContractApproves: [],
        newSendContractApproveAlertClosed: false,
        branches: []
    },
    getters: {
        showNewSendContractApproveAlert(state) {
            return state.sendContractApproves.filter(a => {
                return !a.in_use
            }).length > 0 && !state.newSendContractApproveAlertClosed
        },
        useBranches(state) {
            return state.branches
        }
    },
    mutations: {
        setSendContractApproves(state, payload) {
            state.sendContractApproves = payload
        },
        setNewSendContractApproveAlertClosed(state, payload) {
            state.newSendContractApproveAlertClosed = payload
        },
        setBranches(state, payload) {
            state.branches = payload
        }
    },
    actions: {
        [APP_LOAD_NEW_SEND_CONTRACT_APPROVES]: ({commit}) => {
            SendContractApproveService.getAllByExecutor()
                .then(response => {
                    const approves = response.data.map(a => {
                        return {
                            id: a.id,
                            uid: a.uid,
                            in_use: a.in_use,
                            executor: {
                                inn: a.executor_inn,
                                name: a.executor_name
                            },
                            customer: {
                                inn: a.customer_inn,
                                name: a.customer_name
                            },
                            createdAt: Moment(a.created_at, 'YYYY-MM-DD HH:mm:ss'),
                            updatedAt: Moment(a.updated_at, 'YYYY-MM-DD HH:mm:ss')
                        }
                    })
                    commit('setSendContractApproves', approves)
                })
        },
        [APP_SEND_CONTRACT_APPROVE_ALERT_CLOSE]: ({commit}) => {
            commit('setNewSendContractApproveAlertClosed', true)
        },
        [APP_LOAD_USE_BRANCHES]: ({commit}) => {
            BranchService.getAll()
                .then(response => {
                    const branches = response.data.map(branch => {
                        return {
                            id: branch.Id,
                            code: branch.Code,
                            name: branch.Name,
                            ownerInn: branch.OwnerInn,
                            ownerName: branch.OwnerName
                        }
                    })
                    commit('setBranches', branches)
                })
        }
    }
}